module.exports = __webpack_public_path__ + "img/contributions1Off.75ec6db3.svg";